import { useNavigate } from "fusion-plugin-react-router";
import { assetsPath } from "../../../shared/utils/assetsPath";
import { scrollToTop } from "../../../shared/utils/scrollUtils";

const PortalBackButton = () => {
  const navigate = useNavigate();
  return (
    <div className="multiBtn">
      <button
        type="button"
        className="prevBtn"
        onClick={() => {
          navigate("/landing");
          scrollToTop();
        }}
      >
        <img className="PrevImg" src={assetsPath.previous} alt="Previous" />
      </button>

      <div></div>
    </div>
  );
};

export default PortalBackButton;
